module.exports = __webpack_public_path__ + "static/media/CNC.8786bd15.jpg";